import { Typography, Box } from "@mui/material"
import Layout from "./Layout"

import Email from "../../shared/fields/Email"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import BackButton from "../../shared/buttons/BackButton"
import useAppStore from "../../../store/app"
import useAlertStore from "../../../store/alert"
import { useNavigate } from "react-router-dom"
import useTranslation from "../../../hooks/use_translation"

const ResetPassword = () => {
  const fields = useAppStore((state) => state.fields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const resetPassword = useAppStore((state) => state.resetPassword)

  const showAlert = useAlertStore((state) => state.showAlert)
  const navigate = useNavigate()

  const { pages } = useTranslation()

  const handleSubmit = (e) => {
    e.preventDefault()

    const errorsCheck = ["email"]

    errorsCheck.map((field) => {
      if (!fields[field]?.touched) {
        updateFieldErrorMessage(field, "This field is required")
      }
    })

    const valid = errorsCheck.every((field) => fields[field].error_message === "")

    if (!valid) return

    const params = {
      email: fields.email.input_value,
    }

    resetPassword(params)
      .then(() => {
        navigate("/email_confirmation?action=reset")
      })
      .catch((error) => {
        showAlert(error.message, "error")
      })
  }
  return (
    <Layout>
      <BackButton text={pages?.reset_password?.back_btn} href="/login" />
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
        {pages?.reset_password?.title}
      </Typography>
      <Typography variant="body1">{pages?.reset_password?.subtitle}</Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Email />
        <SecondaryButton fullWidth text={pages?.reset_password?.submit_btn} type="submit" />
      </Box>
    </Layout>
  )
}

export default ResetPassword
